/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Action_TitleInputs */

const cs_form_action_title = /** @type {(inputs: Form_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název úkolu`)
};

const en_form_action_title = /** @type {(inputs: Form_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task title`)
};

/**
* | output |
* | --- |
* | "Task title" |
*
* @param {Form_Action_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_action_title = /** @type {((inputs?: Form_Action_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Action_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_action_title(inputs)
	return cs_form_action_title(inputs)
});